import { useState } from 'react';
import { BsFillPersonCheckFill, BsFillPersonDashFill } from 'react-icons/bs';
import {
  Button,
  Icon,
  Modal,
  ModalFooter,
  useToastNotifications,
} from '@nbirl/nbi-common-ui-libs';

import { useErrorToast } from '../../../shared/hooks';
import { useSetUserStatusMutation } from '../queries';

type EnableUserButtonProps = {
  userId: string;
  userEnabled: boolean;
  disabled?: boolean;
  onStatusChange?: () => void;
};

export const EnableUserButton = ({
  userId,
  userEnabled,
  disabled,
  onStatusChange,
}: EnableUserButtonProps) => {
  const { addToast } = useToastNotifications();
  const mutation = useSetUserStatusMutation();
  const [showModal, setShowModal] = useState<boolean>(false);
  const { showErrorToast } = useErrorToast();

  const handleSetUserStatus = () => {
    const enable = !userEnabled;

    mutation.mutate(
      { userId, enable },
      {
        onSettled: () => {
          setShowModal(false);
        },
        onSuccess: () => {
          onStatusChange && onStatusChange();
          addToast({
            variant: 'success',
            text: enable ? 'User enabled.' : 'User disabled.',
          });
        },
        onError: () => {
          showErrorToast('Something went wrong. Please try again.');
        },
      }
    );
  };
  return (
    <>
      <Button
        variant="outline"
        disabled={disabled}
        onClick={() => setShowModal(true)}
      >
        {`${userEnabled ? 'Disable' : 'Enable'} User`}
      </Button>
      <Modal
        headingIcon={
          <Icon
            icon={
              userEnabled ? <BsFillPersonDashFill /> : <BsFillPersonCheckFill />
            }
          />
        }
        heading={`${userEnabled ? 'Disable' : 'Enable'} User?`}
        isOpen={showModal}
        onDismiss={() => setShowModal(false)}
      >
        {userEnabled ? (
          <p>
            Are you sure you want to disable this user? This will prevent the
            user from accessing the Secure Portal from NBI.
          </p>
        ) : (
          <p>
            Are you sure you want to enable this user? This will allow the user
            to access the Secure Portal from NBI.
          </p>
        )}
        <ModalFooter>
          <Button
            variant="outline"
            disabled={mutation.isLoading}
            onClick={() => setShowModal(false)}
          >
            No, cancel
          </Button>
          <Button onClick={handleSetUserStatus} isPending={mutation.isLoading}>
            {`Yes, ${userEnabled ? 'disable' : 'enable'}`}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};
